import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { RepositoryClient } from '../httpClients/RepositoryClient';
import { BitbucketWizardSelectionOptionsResponse } from '../httpClients/RepositoryClient/api.schema';
import { QUERY_KEYS } from './consts';

type OmittedQueryOptions = Omit<
  UseQueryOptions<
    BitbucketWizardSelectionOptionsResponse,
    Error,
    BitbucketWizardSelectionOptionsResponse
  >,
  'queryKey' | 'queryFn'
>;

export const useBitbucketWizardSelectionOptionsQuery = (
  bitbucketWorkspaceSlug: string | undefined,
  options?: OmittedQueryOptions,
) =>
  useQuery({
    queryKey: [
      QUERY_KEYS.BITBUCKET_WIZARD_SELECTION_OPTIONS,
      bitbucketWorkspaceSlug,
    ],
    queryFn: () => {
      if (!bitbucketWorkspaceSlug) {
        throw new Error('Bitbucket workspace slug is required');
      }

      return RepositoryClient.bitbucketGetWizardSelectionOptions(
        bitbucketWorkspaceSlug,
      );
    },
    enabled: !!bitbucketWorkspaceSlug && (options?.enabled ?? true),
    ...options,
  });
